export default __webpack_public_path__ + "static/media/208.557fb52c.jpg";